import { useState, useEffect } from 'react';
import { message } from 'antd';

import HabilidadesService from './../../../services/alumnos/habilidadesServices';

const H_BLANDAS = 'BLANDAS';
const H_TECNICAS = 'TECNICAS';

const useHabilidades = (initialData = []) => {
    const [habilidadesBlandas, setHabilidadesBlandas] = useState([]);
    const [habilidadesTecnicas, setHabilidadesTecnicas] = useState([]);

    const [editingKey, setEditingKey] = useState('');
    const [loading, setLoading] = useState(false);


    const isEditing = (record) => record.id_habilidad === editingKey;

    const fetchData = async () => {
        setLoading(true);
        const response = await HabilidadesService.getHabilidadesMe()
        setLoading(false);
        if (!response.success) return;
        filterHabilidades(response.data);
    };

    const filterHabilidades = (data) => {
        const blandas = data.filter(habilidad => habilidad.tipo_habilidad === H_BLANDAS);
        const tecnicas = data.filter(habilidad => habilidad.tipo_habilidad === H_TECNICAS);

        setHabilidadesBlandas(blandas);
        setHabilidadesTecnicas(tecnicas);
    };

    useEffect(() => {
        filterHabilidades(initialData);
    }, [initialData]);

    const startEdit = (record) => {
        setEditingKey(record.id_habilidad);
    };

    const cancelEdit = () => {
        setEditingKey('');
        setHabilidadesBlandas((prev) => prev.filter((item) => item.id_habilidad !== null));
        setHabilidadesTecnicas((prev) => prev.filter((item) => item.id_habilidad !== null));
    };

    const saveRecord = async (record) => {
        if (record.id_habilidad === null) {
            delete record.id_habilidad;
            const response = await HabilidadesService.createHabilidad(record);
            if (!response.success) return;
            message.success('Guardado correctamente');
        } else {
            const response = await HabilidadesService.editHabilidad(record);
            if (!response.success) return;
            message.success('Editado correctamente');
        }

        setEditingKey('');
        await fetchData();

        return true;
    };

    const deleteRecord = async (record) => {
        const response = await HabilidadesService.deleteHabilidad(record?.id_habilidad);
        if (!response.success) return;

        message.success('Habilidad eliminada correctamente');
        await fetchData();
    };

    const addRecord = (tipo_habilidad) => {
        if (editingKey) {
            message.warning('Guarda o cancela la fila actual antes de agregar una nueva.');
            return false;
        }

        const newRow = {
            id_habilidad: null,
            habilidad: '',
            tipo_habilidad: tipo_habilidad
        }; 

        if (tipo_habilidad === H_BLANDAS) {
            setHabilidadesBlandas([ newRow, ...habilidadesBlandas ]);
        } else if (tipo_habilidad === H_TECNICAS) {
            setHabilidadesTecnicas([ newRow, ...habilidadesTecnicas]);
        }

        setEditingKey(null);
        return true;
    };

    return {
        habilidadesBlandas,
        habilidadesTecnicas,
        editingKey,
        isEditing,
        startEdit,
        cancelEdit,
        saveRecord,
        deleteRecord,
        addRecord,
        loading
    };
};

export default useHabilidades;
